export const GET_TICKETS = '/api/v1/ticket/history';
export const GET_TICKET_CATEGORIES = '/api/v1/ticket/getCategories';
export const NEW_TICKET = '/api/v1/ticket/newTicket';
export const GET_TICKET = '/api/v1/ticket/listDetails';
export const ATTACH_FILE_TICKET = '/api/v1/ticket/upload';
